/**
 * AgentMessageContent — minimal markdown renderer для финального ответа агента.
 *
 * Не такой богатый как AITutorMessageContent (нет [demo:] / [demo-run:] / SQL_PLACEHOLDER —
 * агент возвращает обычный markdown с ```sql блоками без интерактивных Run кнопок).
 */
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface Props {
  content: string;
}

export default function AgentMessageContent({ content }: Props) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        code({ className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || "");
          const isBlock = !!match;
          if (isBlock) {
            return (
              <pre className="bg-gray-900 text-gray-100 rounded p-3 overflow-x-auto text-sm">
                <code className={className} {...props}>{children}</code>
              </pre>
            );
          }
          return (
            <code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-sm" {...props}>
              {children}
            </code>
          );
        },
        a({ href, children, ...props }) {
          return (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 underline"
              {...props}
            >
              {children}
            </a>
          );
        },
      }}
    >
      {content}
    </ReactMarkdown>
  );
}
